export default __webpack_public_path__ + "static/pro-dumpster-service-7ec0974d24ecabec486082a608bf43ad.jpg";